import { z } from 'zod';
import { LIMIT_200 } from '@anytag/shared-constants';
import { SearchSchema } from '@anytag/shared-validations';
import { Order, TiktokUserTagPostsSortOrder } from '@anytag/graphql';
import { TagsAnalyticsSearchSchema } from '../../shared';

export const TiktokTagsAnalyticsSearchSchema = TagsAnalyticsSearchSchema.extend({
  limit: z.number().default(LIMIT_200), // Override default 50
  sort: SearchSchema.types.sort(TiktokUserTagPostsSortOrder).default({
    order: Order.ASC,
    field: TiktokUserTagPostsSortOrder.RANK
  })
});
export type TiktokTagsAnalyticsSearchSchemaType = z.infer<typeof TiktokTagsAnalyticsSearchSchema>;
